function isArray(value) {
  return !!value && value.constructor.name === 'Array';
}
function isValidArray(value) {
  return isArray(value) && !!value.length;
}

export { isArray, isValidArray };
